<template>
  <!--
      作者：gmshop
      时间：2020-06-25
      描述：插件中心-限时拼团
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="商品管理" name="first"><Product v-if="activeName == 'first'"></Product></el-tab-pane>
      <el-tab-pane label="商品类目" name="second"><shopCat v-if="activeName == 'second'"></shopCat></el-tab-pane>
      <el-tab-pane label="基础设置" name="third"><Setting v-if="activeName == 'third'"></Setting></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Product from './product/index.vue';
import shopCat from './shopcat/index.vue';
import Setting from './setting/setting.vue';
export default {
  components: {
    /*商品管理*/
    Product,
    /*类目管理*/
    shopCat,
    /*基础设置*/
    Setting
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      activeName: 'first'
    };
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ministore/index.vue